;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "khWTKx9t03"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {

  let items = $(this).find('.lh-item');

  let eventAc = function(dom) {
    let titles = dom.find('.lh-title');
    let contents = dom.find('.lh-content');

    titles.each( function(i) {
      this.addEventListener('click', () => {
        let wrap = this.parentNode;
        let currentHasAc = wrap.classList.contains('active');
        if(!currentHasAc) {
          wrap.classList.add('active');
          contents[i].style.maxHeight = `${contents[i].scrollHeight}px`
        } else {
          wrap.classList.remove('active')
          contents[i].style.maxHeight = 0;
        }
      });
    });
  }

  eventAc(items);

 };						cb.bind($('section[data-section-id="khWTKx9t03"] include[data-name="style_3"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="khWTKx9t03"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWFyLS0yMDIx/NjE1Mjc3MDI3/release-3-2021/pages/XHk1fncsSzFE4PU8/faqs/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');window.addEventListener("load",()=>{let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 15px","width: 100%","text-align: center","opacity: 1","z-index: 10000000000000000","text-indent: 0","color: #333","background: #fff",""].join(" !important;")),b.innerHTML="Page layout provided by &hearts; <a href=\"https://www.layouthub.com/?utm_source=client-site&utm_medium=footer&utm_campaign=freemium&utm_term=links&utm_content="+window.location.origin+"\">Layouthub.com</a>",a.appendChild(b)});